
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Découvrez toutes les astuces pour réussir votre SEA en 2026",
    description:
      "Comment faire du SEA en 2026 avec les dernières mises à jour de Google ? Optimisez vos campagnes pour obtenir de meilleurs résultats grâce à nos conseils.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
